export default function(instance) {
  return {
    getEmployees(data) {
      Object.keys(data).forEach(
        k => !data[k] && data[k] !== undefined && delete data[k]
      );

      return instance.get("/api/employees/", { params: data });
    },
    createEmployee(data) {
      return instance.post("/api/employees/", {
        phone: data.phone,
        full_name: data.full_name,
        password: data.password,
        is_staff: data.is_staff,
        is_security: data.is_security,
        is_cafe_personal: data.is_cafe_personal,
        is_market_personal: data.is_market_personal
      });
    },
    getEmployee(idEmployee) {
      return instance.get(`/api/employees/${idEmployee}/`);
    },
    updateEmployee(idEmployee, data) {
      return instance.put(`/api/employees/${idEmployee}/`, {
        phone: data.phone,
        full_name: data.full_name,
        is_staff: data.is_staff,
        is_security: data.is_security,
        is_cafe_personal: data.is_cafe_personal,
        is_market_personal: data.is_market_personal
      });
    },
    deleteEmployee(idEmployee) {
      return instance.delete(`/api/employees/${idEmployee}/`);
    }
  };
}
